module.exports = __webpack_public_path__ + "img/figure-5.69c214ab.png";